module.exports = __webpack_public_path__ + "img/noimage.d28e6ab4.png";